const PrimaryButton = ({
  onClick,
  title = '',
}: {
  onClick: any;
  title?: string;
}) => {
  return (
    <button
      onClick={onClick}
      className='m-auto mr-3 rounded-full border-[2px] border-warning bg-warning px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase text-black transition-colors duration-500 hover:border-[#e6f7f8] hover:bg-[#e6f7f8]'
    >
      {title}
    </button>
  );
};

export default PrimaryButton;
